module.exports = __webpack_public_path__ + "img/yellow_pet_card.2c5291e4.svg";